import { useSelector } from "react-redux";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { WithChildren } from "_metronic/helpers";
import { selectIsBusy, selectBusyMessage } from "./GlobalActivityIndicatorSlice";
import { TicTacToe } from "app/modules/cpltest/tictactoe/TicTacToe";

export const GlobalActivityIndicator: React.FC<WithChildren> = ({ children }) => {
  const isBusy = useSelector(selectIsBusy);
  const busyMessage = useSelector(selectBusyMessage);

  let globalActivityEntertainment;
  const showEntertainment = Math.floor(Math.random() * 10) === 0; // = 10% chance of appearing
  if (isBusy && showEntertainment) {
    globalActivityEntertainment = (
      <div id="global-activity-entertainment">
        Fancy a game while you wait?
        <TicTacToe />
      </div>
    );
  }

  return (
    <>
      <ActivityIndicator id="global-activity-indicator" isBusy={isBusy} busyMessage={busyMessage} size="20px">
        {children}
      </ActivityIndicator>
      {globalActivityEntertainment}
    </>
  );
};
